<template>
  <div
    :data-test="`${cyComponent}--token-profile`"
  >
    <div v-if="tokensForTrade.length">
      <div
        v-for="(data, index) in tokensForTrade"
        :key="index"
      >
        <div
          :data-test="`${cyComponent}--token-profile-card`"
          class="card">
          <div
            :data-test="`${cyComponent}--token-info`"
            class="token-info"
          >
            <div class="half">
              <div class="token-name-img">
                <img :src="`/static/token/normal/${data.code.toLowerCase()}.svg`">
              </div>
              <div class="token-name-lable">
                <div
                  :data-test="`${cyComponent}--token-code`"
                  lass="token-name-lable-code"
                >
                  {{ data.code }}
                </div>
                <div class="token-name-lable-fullname">
                  {{ data.name }}
                </div>
              </div>
            </div>
            <div class="half">
              <div class="price-volume-text-head-left">{{ $t('exchange.change_24_hr') }}</div>
              <div class="price-volume-text-body-left">
                <span
                  :data-test="`${cyComponent}--token-price`"
                  class="price"
                >
                  ${{ data.price | toFixedDecimal }}
                </span>
                <span
                  :class="[
                    'change-col-text',
                    {
                      'is-green': data.change > 0,
                      'is-black': data.change === 0,
                      'is-red': data.change < 0
                    }
                  ]"
                  :data-test="`${cyComponent}--price-change`"
                >
                  (<span v-if="data.change > 0">+</span>{{ data.change | toFixedDecimal }} %)
                </span>
              </div>
            </div>
          </div>
          <div
            :data-test="`${cyComponent}--button-footer`"
            class="button-footer"
          >
            <button
              :data-test="`${cyComponent}--buy-token-button`"
              class="button is-text buy-sell-col-buy-btn"
              @click="onBuyClicked(data)"
            >
              {{ $t('exchange.buy') }}
            </button>
            <button
              :data-test="`${cyComponent}--sell-token-button`"
              class="button is-text buy-sell-col-sell-btn"
              @click="onSellClicked(data)"
            >
              {{ $t('exchange.sell') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!tokensForTrade.length">
      <div
        v-for="(index) in 4"
        :key="index"
      >
        <div class="card">
          <div class="token-info">
            <div class="half">
              <div class="token-name-img">
                <b-skeleton
                  width="50px"
                  height="50px"
                  circle
                />
              </div>
              <div class="token-name-lable">
                <div class="token-name-lable-code skt">
                  <b-skeleton/>
                </div>
                <div class="token-name-lable-fullname skt">
                  <b-skeleton/>
                </div>
              </div>
            </div>
            <div class="half">
              <div class="price-volume-text-head-left skt">
                <b-skeleton height="30px"/>
              </div>
            </div>
          </div>
          <div class="button-footer">
            <div class="btn-skt"><b-skeleton height="30px"/></div>
            <div class="btn-skt"><b-skeleton height="30px"/></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * TokenProfile Component
 */

export default {
  name: 'MobileCard',
  props: {
    tokensForTrade: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cyComponent: 'mobile-card'
    }
  },
  methods: {
    onBuyClicked (target) {
      this.$emit('buyEvent', target)
    },
    onSellClicked (source) {
      this.$emit('sellEvent', source)
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  float: left;
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  margin: 7.5px 0px;
}
.token-info{
  float: left;
  width: 100%;
  padding: 15px;
}
.token-name-img {
  float: left;
  width: 40px;
}
.token-name-img img {
  width: 100%;
}
.token-name-lable {
  float: left;
  margin-left: 10px;
  width: calc(100% - 50px);
}
.token-name-lable-fullname {
  font-family: Roboto;
  font-size: 12px;
  color: #646464;
  letter-spacing: 0.3px;
  &.skt {
    width: 100%;
    margin: 0 0 15px 10px;
  }
}
.token-name-lable-code {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  letter-spacing: 0.4px;
  line-height: 1.2;
  &.skt {
    width: 60%;
    margin: 0 0 15px 10px;
  }
}
.price-volume-text-head-left {
  float: right;
  width: 100%;
  font-size: 12px;
  color: #363636;
  text-align: right;
  margin-bottom: 5px;
  &.skt {
    width: 50%;
  }
}
.price-volume-text-body-left {
  width: 100%;
  float: right;
  text-align: right;
}
.change-col-text {
  font-family: DINAlternate !important;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  font-weight: 500;
}
.half {
  float: left;
  width: 50%;
}
.is-red {
  color: #e90000;
}
.is-green {
  color: #3eaf34;
}
.is-black {
  color: #000000;
}
.change-text-black {
  font-family: DINAlternate !important;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}
.price {
  font-family: DINAlternate !important;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #00aeff;
}
.volume {
  font-family: DINAlternate !important;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3b3b3b;
}
.button-footer {
  float: left;
  width: 100%;
  text-align: right;
  margin: 15px 0;
  padding: 0px 15px;
}
.is-text {
  text-decoration: none !important;
}
.buy-sell-col-buy-btn {
  width: 83px;
  height: 40px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #3eaf34 !important;
  border: 1px solid #3eaf34;
  margin-right: 10px;
}
.buy-sell-col-sell-btn {
  width: 83px;
  height: 40px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #e90000 !important;
  border: 1px solid #e90000;
}
.btn-skt {
  width: 70px;
  float: right;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/features/TokenProfile/components/MobileCard.vue